import React, { useState, useEffect, useRef } from 'react'
import { Avatar, Image, Link } from 'newComponents'
import openQuotes from '../../../images/about-us/Quotes_v2_Blue.svg'
import './styles.scss'

const Carousel = (props) => {
  const [activeQuote, setActiveQuote] = useState(0)
  const timeoutRef = useRef()
  const { quotes } = props

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      const nextIndex = activeQuote === quotes.length - 1 ? 0 : activeQuote + 1
      setActiveQuote(nextIndex)
    }, 6000)
  }, [activeQuote])

  const handleClick = (event, index) => {
    event.preventDefault()
    clearTimeout(timeoutRef.current)
    setActiveQuote(index)
  }

  const quote = quotes[activeQuote]

  return (
    <div>
      <div className="container carousel-quote" key={quote.quote}>
        <Image image={openQuotes} alt="quotation" className="carousel-quote-icon" />
        <div className="carousel-content">
          <div className="carousel-content-subcontainer">
          <h2 className="carousel-quote-text">{quote.quote}</h2>
          <Avatar avatar={quote.avatar} fullName={quote.fullName} jobTitle={quote.jobTitle} lightText />
          </div>
          <div className="carousel-dots">
            {quotes.map((q, index) => (
              <Link to="#" onClick={(event) => handleClick(event, index)}>
                <div className={`carousel-dot ${index === activeQuote ? 'carousel-active-dot' : ''}`}>
                  <span className="carousel-dot-inner" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Carousel
